import store from "@/store";
export default{
    linkDataId: "",
    clockType: 0,
    clockState: 0,
    matterItem: {},
    childItem: {},
    getClockData: function(matterItem, childItem, clockState){
        const listClockList = [];
        this.matterItem = matterItem;
        this.childItem = childItem;
        this.setClockInfo(clockState);

        const clockArray = store.state.listModules.tbListClock.filter((item)=>{
            return item.linkDataId === this.linkDataId
                && item.clockDate === this.matterItem.timeInfo.clockTargetDate
        })
        if(clockArray.length === 0){
            // 创建记录
            listClockList.push({
                userId: store.state.userId,
                linkDataId: this.linkDataId,
                clockDate: this.matterItem.timeInfo.clockTargetDate,
                clockTimeStamp: Date.now(),
                clockState: this.clockState,
                clockType: this.clockType,
                dataAction: "add",
            })
        }else{
            // 更新记录
            const clockItem = clockArray[0];
            clockItem.clockState = this.clockState;
            clockItem.clockTimeStamp = Date.now();
            clockItem.dataAction = "update";
            listClockList.push(clockItem);
        }

        if(this.matterItem.timeInfo.state <= 0 && this.clockType === 1 && this.clockState > 0){
            // 查询子任务是否全部完成

            const notClockArray = this.matterItem.childArray.filter((item)=>{
                return item.timeInfo.state === 0
            })
            if(notClockArray.length === 1){
                const matterClockItem = this.getMatterClock();
                listClockList.push(matterClockItem);
            }
        }
        return listClockList
    },
    setClockInfo: function(clockState){
        let linkDataId, timeInfo, clockType;
        if(this.childItem.info){
            linkDataId = this.childItem.info.childId;
            timeInfo = this.childItem.timeInfo;
            clockType = 1;
        }else{
            linkDataId = this.matterItem.info.inventoryId;
            timeInfo = this.matterItem.timeInfo;
            clockType = 0;
        }
        if(!clockState){
            if(timeInfo.state > 0){
                clockState = 0
            }else{
                clockState = 1
            }
        }
        this.linkDataId = linkDataId;
        this.clockState = clockState;
        this.clockType = clockType;
    },
    getMatterClock: function(){

        const inventoryId = this.matterItem.info.inventoryId;

        const clockArray = this.tbListClock.filter((item)=>{
            return item.linkDataId === inventoryId
                && item.clockDate === this.matterItem.timeInfo.clockTargetDate
        })
        let matterClockItem;
        if(clockArray.length === 0){
            // 创建
            matterClockItem = {
                userId: store.state.userId,
                linkDataId: inventoryId,
                clockDate: this.matterItem.timeInfo.clockTargetDate,
                clockTimeStamp: Date.now(),
                clockState: 1,
                clockType: 0,
                dataAction: "add",
            }
        }else{
            // 更新
            matterClockItem = clockArray[0];
            matterClockItem.clockTimeStamp = Date.now();
            matterClockItem.clockState = 1;
            matterClockItem.dataAction = "update";
        }
        return matterClockItem
    },
}